import { render } from "./VehicleBrand.vue?vue&type=template&id=4533b995"
import script from "./VehicleBrand.vue?vue&type=script&lang=js"
export * from "./VehicleBrand.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__